import "core-js/modules/es.array.push.js";
import { computed, h, isVNode } from 'vue';
import { useRouter } from 'vue-router';
export default {
  name: 'XNavItem',
  props: {
    icon: {
      type: [String, Object],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    extra: {
      type: String,
      default: ''
    },
    to: {
      type: [String, Function, Object]
    },
    target: {
      type: String,
      default: '_self'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props, {
    emit
  }) {
    const router = useRouter();
    const iconComp = computed(() => {
      const {
        icon
      } = props || {};
      if (!icon) return null;
      if (typeof icon === 'string') {
        return h('i', {
          class: icon
        });
      }
      if (isVNode(icon)) {
        return () => icon;
      }
      if (typeof icon === 'object' && icon.render) {
        return h(icon);
      }
      if (typeof icon === 'function') {
        return h(icon);
      }
      return null;
    });
    const handleClick = () => {
      emit('click');
      if (!props.to) return;
      if (typeof props.to === 'function') {
        props.to();
      } else if (typeof props.to === 'string') {
        if (props.target === '' || props.target === '_self') {
          router.push({
            path: props.to
          });
        } else {
          const link = router.resolve({
            path: props.to
          });
          window.open(link.href, props.target);
        }
      } else if (typeof props.to === 'object' && !!props.to.path) {
        router.push(props.to);
      }
    };
    return {
      iconComp,
      handleClick
    };
  }
};